module.exports = require('./helpers/bundle-url').getBundleURL('aMO4G') + "logo-dark.eefe0b7f.svg";